import { Link } from "react-router-dom";

const cta: React.CSSProperties = {
  display: "inline-block",
  backgroundColor: "#4AA0A0",
  color: "#ffffff",
  textDecoration: "none",
  fontWeight: 600,
  fontSize: 16,
  padding: "12px 28px",
  borderRadius: 40,
};

export function NotFound() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Afacad",
        padding: 24,
        textAlign: "center",
      }}
    >
      <div style={{ maxWidth: 640 }}>
        <img
          src="/logo.png"
          alt="Tribeca Printworks"
          style={{ maxWidth: 220, margin: "0 auto 32px", display: "block" }}
        />
        <h1 style={{ fontSize: 34, marginBottom: 8, color: "#1a1a1a" }}>
          You&rsquo;re in the right place!
        </h1>
        <p style={{ color: "#5f6b6b", fontSize: 17, marginBottom: 24 }}>
          That exact page isn&rsquo;t on our new studio &mdash; but nothing is
          lost, and everything is close by.
        </p>
        <div
          style={{
            backgroundColor: "#dbf1f1",
            border: "1px solid #b7e0e0",
            borderRadius: 10,
            padding: "16px 20px",
            fontSize: 15.5,
            lineHeight: 1.6,
            color: "#333333",
            textAlign: "left",
            marginBottom: 28,
          }}
        >
          Our original ordering site &mdash; including your account,
          uploads, and order history &mdash; now lives at{" "}
          <a
            href="https://legacy.tribecaprintworks.com"
            style={{ color: "#2b807d", fontWeight: 600 }}
          >
            legacy.tribecaprintworks.com
          </a>
          .
        </div>
        <p style={{ color: "#5f6b6b", fontSize: 16, marginBottom: 16 }}>
          Or come and explore the new and improved Tribeca Printworks
          Online Studio &mdash; no account needed:
        </p>
        <div
          style={{
            display: "flex",
            gap: 14,
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <Link to="/upload" style={cta}>
            Upload your artwork
          </Link>
          <Link to="/visualizer?sample=1" style={cta}>
            See pricing with our sample image
          </Link>
        </div>
      </div>
    </div>
  );
}
